module.exports = __webpack_public_path__ + "static/img/top-logo.8434b33.png";